import { tv } from "../../variants/tv.js";
const spinnerVariants = tv({
    slots: {
        circleSlot: '',
        spinnerSlot: '',
        iconSlot: 'text-primary-8',
        wrapperSlot: 'animate-fade-in-0-100'
    },
    variants: {
        size: {
            xs: {
                wrapperSlot: 'w-4'
            },
            sm: {
                wrapperSlot: 'w-6'
            },
            md: {
                wrapperSlot: 'w-16'
            },
            lg: {
                wrapperSlot: 'w-28'
            },
            xl: {
                wrapperSlot: 'w-36'
            }
        },
        emphasis: {
            regular: '',
            medium: '',
            bold: ''
        },
        palette: {
            primary: '',
            highlight: ''
        }
    },
    defaultVariants: {
        size: 'md',
        emphasis: 'regular',
        palette: 'primary'
    },
    compoundVariants: [
        {
            emphasis: 'regular',
            palette: 'primary',
            class: {
                circleSlot: 'var(--color-primary-4)',
                spinnerSlot: 'var(--color-primary-8)'
            }
        },
        {
            emphasis: 'medium',
            palette: 'primary',
            class: {
                circleSlot: 'var(--color-primary-7)',
                spinnerSlot: 'var(--color-primary-8)'
            }
        },
        {
            emphasis: 'bold',
            palette: 'primary',
            class: {
                circleSlot: 'color-mix(in oklab, var(--color-actionSecondary-1) 20%, transparent)',
                spinnerSlot: 'var(--color-primary-2)',
                iconSlot: 'text-primary-2'
            }
        },
        {
            emphasis: 'regular',
            palette: 'highlight',
            class: {
                circleSlot: 'var(--color-highlight-4)',
                spinnerSlot: 'var(--color-highlight-8)',
                iconSlot: 'text-highlight-8'
            }
        },
        {
            emphasis: 'medium',
            palette: 'highlight',
            class: {
                circleSlot: 'var(--color-highlight-4)',
                spinnerSlot: 'var(--color-highlight-8)',
                iconSlot: 'text-highlight-8'
            }
        },
        {
            emphasis: 'bold',
            palette: 'highlight',
            class: {
                circleSlot: 'color-mix(in oklab, var(--color-highlight-1) 20%, transparent)',
                spinnerSlot: 'var(--color-highlight-2)',
                iconSlot: 'text-highlight-2'
            }
        }
    ]
});
const sizeOptions = Object.keys(spinnerVariants.variants.size);
const emphasisOptions = Object.keys(spinnerVariants.variants.emphasis);
const paletteOptions = Object.keys(spinnerVariants.variants.palette);
export { emphasisOptions, paletteOptions, sizeOptions, spinnerVariants };
